import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import PullToRefresh from "react-simple-pull-to-refresh";
import "styles/index.scss";

import { POWER_PLANT, RECORDS, useRefreshPrices } from "api";
import { DashboardPage } from "routes";
import { getSelectedPowerPlant, useAppSelector } from "store";
import { sourceFlashDurationMs } from "styles/animations";
import { isPWA } from "utils/detectDevice";
import { useFlashOnce } from "utils/hooks/useFlashOnce";

import { Navbar } from "./Navbar";
import { Status } from "./Navbar/components";

export const MainContent = () => {
  const selectedPowerPlant = useAppSelector(getSelectedPowerPlant);
  const queryClient = useQueryClient();
  // The dashboard carries the latest-prices widget, so a pull refreshes the
  // prices too — as a manual refresh, same as the button on the prices page —
  // and reveals each source's age afterwards so the pull visibly did something.
  const { refresh: refreshPrices } = useRefreshPrices();
  const { flashId: pricesFlashId, flash: flashPrices } = useFlashOnce(
    sourceFlashDurationMs,
  );

  const [belowStatus, setBelowStatus] = useState(false);

  return (
    <>
      <Navbar belowStatus={belowStatus} />
      <PullToRefresh
        isPullable={isPWA()}
        onRefresh={() =>
          Promise.all([
            queryClient
              .invalidateQueries({
                queryKey: [
                  POWER_PLANT.POWER_PLANT_LIVE(
                    selectedPowerPlant?.meterId || "",
                  ),
                ],
              })
              .then(() =>
                queryClient.refetchQueries({
                  queryKey: [
                    POWER_PLANT.POWER_PLANT_LIVE(
                      selectedPowerPlant?.meterId || "",
                    ),
                  ],
                  stale: true,
                }),
              ),
            queryClient.refetchQueries({
              queryKey: [RECORDS.RECORDS(selectedPowerPlant?.meterId || "")],
              exact: false,
            }),
            refreshPrices(),
          ]).then(() => {
            flashPrices();
            return true;
          })
        }
        pullingContent={<></>}
      >
        <>
          <Status setBelowStatus={setBelowStatus} />
          <DashboardPage pricesFlashId={pricesFlashId} />
        </>
      </PullToRefresh>
    </>
  );
};
